// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".products-data-table__image{width:4rem;height:4rem}.products-data-table__collections{margin:1px}", ""]);
// Exports
module.exports = exports;
